'use client';
import dynamic from 'next/dynamic';
import { NextIntlClientProvider } from 'next-intl';
import type { Card } from '../../types/card';
import type { Messages } from 'next-intl';
import type { FAQItem } from '@/src/utils/faqBuilder';

const ProductBelowFold2 = dynamic(
    () => import('./ProductBelowFold').then(m => ({ default: m.ProductBelowFold2 }))
);

export const ProductBelowFoldLazy: React.FC<{ card: Card; messages: Messages; locale: string; faqItems?: FAQItem[] }> = ({ card, messages, locale, faqItems }) => {
    return (
        <NextIntlClientProvider messages={messages} locale={locale}>
            <ProductBelowFold2 card={card} faqItems={faqItems} />
        </NextIntlClientProvider>
    );
};
